import { render, staticRenderFns } from "./qywx.vue?vue&type=template&id=72b408c6&"
import script from "./qywx.vue?vue&type=script&lang=js&"
export * from "./qywx.vue?vue&type=script&lang=js&"
import style0 from "./qywx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports